export enum NotificationTopic {
  ABSENCE_LONG_START = 'ABSENCE_LONG_START',
  ABSENCE_LONG_END = 'ABSENCE_LONG_END',
  ALLOWANCE_PROPOSED = 'ALLOWANCE_PROPOSED',
  ALLOWANCE_REJECTED = 'ALLOWANCE_REJECTED',
  BANK_ACCOUNT_UPDATED = 'BANK_ACCOUNT_UPDATED',
  BENEFIT_PROPOSED = 'BENEFIT_PROPOSED',
  BENEFIT_REJECTED = 'BENEFIT_REJECTED',
  CANDIDATE_ADVANCED = 'CANDIDATE_ADVANCED',
  CANDIDATE_CREATED = 'CANDIDATE_CREATED',
  COLLAB_TASK_COMMENT_CREATED = 'COLLAB_TASK_COMMENT_CREATED',
  COLLAB_TASK_COMMENT_DELETED = 'COLLAB_TASK_COMMENT_DELETED',
  COLLAB_TASK_COMMENT_UPDATED = 'COLLAB_TASK_COMMENT_UPDATED',
  DOCUMENT_EXPIRATION = 'DOCUMENT_EXPIRATION',
  DOCUMENT_APPROVED = 'DOCUMENT_APPROVED',
  DOCUMENT_REJECTED = 'DOCUMENT_REJECTED',
  EARLY_INVOLVEMENT_NEXT_ACTIVITY = 'EARLY_INVOLVEMENT_NEXT_ACTIVITY',
  PERF_APPRAISAL_TEMPLATE_EXPIRY = 'PERF_APPRAISAL_TEMPLATE_EXPIRY',
  PERF_PROCESS_TEMPLATE_EXPIRY = 'PERF_PROCESS_TEMPLATE_EXPIRY',
  EMPLOYEE_BIRTHDAY = 'EMPLOYEE_BIRTHDAY',
  EMPLOYEE_CONTACT_UPDATED = 'EMPLOYEE_CONTACT_UPDATED',
  EMPLOYEE_DATA_EXPIRED = 'EMPLOYEE_DATA_EXPIRED',
  EMPLOYEE_EMPLOYMENT_END = 'EMPLOYEE_EMPLOYMENT_END',
  EMPLOYEE_EMPLOYMENT_PLANNED_END = 'EMPLOYEE_EMPLOYMENT_PLANNED_END',
  EMPLOYEE_EMPLOYMENT_START = 'EMPLOYEE_EMPLOYMENT_START',
  EMPLOYEE_POSITION_UPDATED = 'EMPLOYEE_POSITION_UPDATED',
  EMPLOYEE_TRIAL_END = 'EMPLOYEE_TRIAL_END',
  EMPLOYEE_WORKANNIVERSARY = 'EMPLOYEE_WORKANNIVERSARY',
  EMPLOYMENT_DETAILS_APPROVED = 'EMPLOYMENT_DETAILS_APPROVED',
  EMPLOYMENT_DETAILS_PROPOSED = 'EMPLOYMENT_DETAILS_PROPOSED',
  EMPLOYMENT_DETAILS_UPDATED = 'EMPLOYMENT_DETAILS_UPDATED',
  EMPLOYMENT_UPDATED = 'EMPLOYMENT_UPDATED',
  EMPLOYMENT_WORKING_HOURS_UPDATED = 'EMPLOYMENT_WORKING_HOURS_UPDATED',
  EQUIPMENT_CREATED = 'EQUIPMENT_CREATED',
  EQUIPMENT_DELETED = 'EQUIPMENT_DELETED',
  EQUIPMENT_EDITED = 'EQUIPMENT_EDITED',
  EQUIPMENT_EXPIRATION = 'EQUIPMENT_EXPIRATION',
  INCENTIVE_SHORT_PROPOSED = 'INCENTIVE_SHORT_PROPOSED',
  INCENTIVE_SHORT_REJECTED = 'INCENTIVE_SHORT_REJECTED',
  JOB_APP_RECEIVED = 'JOB_APP_RECEIVED',
  JOB_OPENING_APPROVED = 'JOB_OPENING_APPROVED',
  JOB_OPENING_PROPOSED = 'JOB_OPENING_PROPOSED',
  JOB_OPENING_REJECTED = 'JOB_OPENING_REJECTED',
  MANAGER_EMPLOYMENT_END = 'MANAGER_EMPLOYMENT_END',
  PROVISIONAL_EMP_ADVANCED = 'PROVISIONAL_EMP_ADVANCED',
  PROVISIONAL_EMP_CREATED = 'PROVISIONAL_EMP_CREATED',
  RECRUITING_DATA_EXPIRED = 'RECRUITING_DATA_EXPIRED',
  RECRUITING_DATA_EXPIRING = 'RECRUITING_DATA_EXPIRING',
  SALARY_CHANGED = 'SALARY_CHANGED',
  SALARY_PROPOSED = 'SALARY_PROPOSED',
  SALARY_REJECTED = 'SALARY_REJECTED',
  SICK_LEAVES_LIMIT_BREACH = 'SICK_LEAVES_LIMIT_BREACH',
  SICK_LEAVES_DAYS_LIMIT_BREACH = 'SICK_LEAVES_DAYS_LIMIT_BREACH',
  SYS_PERFORMANCE_GOAL = 'SYS_PERFORMANCE_GOAL',
  TRAINING_EXPIRATION = 'TRAINING_EXPIRATION',
  TRAINING_APPROVAL_STATUS_INT_PARTICIPANT = 'TRAINING_APPROVAL_STATUS_INT_PARTICIPANT',
  TRAINING_PARTICIPANT_REG_STATUS = 'TRAINING_PARTICIPANT_REG_STATUS',
  TRAINING_PARTICIPANT_COMPLETION_STATUS = 'TRAINING_PARTICIPANT_COMPLETION_STATUS',
  UNIT_MANAGER_CHANGED = 'UNIT_MANAGER_CHANGED',
  BILLABLE_HOURS_APPROVED = 'BILLABLE_HOURS_APPROVED',
  BILLABLE_HOURS_PROPOSED = 'BILLABLE_HOURS_PROPOSED',
  BILLABLE_HOURS_REJECTED = 'BILLABLE_HOURS_REJECTED',
  COLLAB_TASK_CREATED = 'COLLAB_TASK_CREATED',
  COLLAB_TASK_UPDATED = 'COLLAB_TASK_UPDATED',
  COLLAB_TASK_COMPLETED = 'COLLAB_TASK_COMPLETED',
  PERF_STATUS_DISCUSSION_EXPIRED = 'PERF_STATUS_DISCUSSION_EXPIRED',
  ABSENCE_SHORT_CREATE = 'ABSENCE_SHORT_CREATE',
  ABSENCE_SHORT_UPDATE = 'ABSENCE_SHORT_UPDATE',
  ABSENCE_SHORT_DELETED = 'ABSENCE_SHORT_DELETED',
  ABSENCE_LONG_CREATE = 'ABSENCE_LONG_CREATE',
  ABSENCE_LONG_UPDATE = 'ABSENCE_LONG_UPDATE',
  ABSENCE_LONG_DELETED = 'ABSENCE_LONG_DELETED',
  PERF_GOAL_UPDATE = 'PERF_GOAL_UPDATE',
  DEV_COMPETENCY_UPDATE = 'DEV_COMPETENCY_UPDATE',
  DEV_PLAN_UPDATE = 'DEV_PLAN_UPDATE',
  SICK_DAYS_LIMIT_BREACH = 'SICK_DAYS_LIMIT_BREACH',
  ALLOWANCE_APPROVED = 'ALLOWANCE_APPROVED',
  BENEFIT_APPROVED = 'BENEFIT_APPROVED',
  INCENTIVE_SHORT_APPROVED = 'INCENTIVE_SHORT_APPROVED',
  SALARY_APPROVED = 'SALARY_APPROVED',
  WORKLIST_CREATED = 'WORKLIST_CREATED',
  WORKLIST_COMPLETED = 'WORKLIST_COMPLETED',
  WORKLIST_TASK_CREATED = 'WORKLIST_TASK_CREATED',
  WORKLIST_TASK_UPDATED = 'WORKLIST_TASK_UPDATED',
  WORKLIST_TASK_COMPLETED = 'WORKLIST_TASK_COMPLETED',
}

export enum NotificationArea {
  NONE = 'NONE',
  PEOPLE = 'PEOPLE',
  REWARDING = 'REWARDING',
  RECRUITING = 'RECRUITING',
  PERFORMANCE = 'PERFORMANCE',
  DEVELOPMENT = 'DEVELOPMENT',
  COLLABORATION = 'COLLABORATION',
  OPENJOB = 'OPENJOB',
  ANALYTICS = 'ANALYTICS',
  EARLY_INVOLVEMENT = 'EARLY_INVOLVEMENT',
}

export enum NotificationSubArea {
  NONE = 'NONE',
  CONTACT = 'CONTACT',
  GENERAL = 'GENERAL',
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  BASIC_DATA = 'BASIC_DATA',
  NEW_POSITIONS = 'NEW_POSITIONS',
  PROVISIONAL_EMPLOYEES = 'PROVISIONAL_EMPLOYEES',
  ABSENCES = 'ABSENCES',
  COLLABORATION = 'PEOPLE_COLLABORATION',
  GOAL_SETTING = 'GOAL_SETTING',
  COMPETENCIES = 'COMPETENCIES',
  DEVELOPMENT_PLAN = 'DEVELOPMENT_PLAN',
  INCENTIVES = 'INCENTIVES',
  ARCHIVED_POSITIONS = 'ARCHIVED_POSITIONS',
  EDUCATION = 'EDUCATION',
  DOCUMENTS = 'DOCUMENTS',
  EQUIPMENT = 'EQUIPMENT',
  BENEFITS = 'BENEFITS',
  OPEN_POSITIONS_NEW = 'OPEN_POSITIONS_NEW',
  FORMER_EMPLOYEES = 'FORMER_EMPLOYEES',
  ARCHIVED_CANDIDATES = 'ARCHIVED_CANDIDATES',
  STATUS_DISCUSSION = 'STATUS_DISCUSSION',
  PROCESS_EVAL = 'PROCESS_EVAL',
  APPRAISAL_EVALUTION = 'APPRAISAL_EVALUTION',
  BILLABLE_HOURS = 'BILLABLE_HOURS',
}
